export default "__VITE_ASSET__bd147a98__"